    package com.cybersoftsolution.futures.base.models

    import kotlinx.serialization.Polymorphic
    import kotlinx.serialization.SerialName
    import kotlinx.serialization.Serializable




    @Serializable
    actual open class Response<T>  actual constructor(actual val data: T? , actual val  message: String?)

    @SerialName("success")
    @Polymorphic
    actual class Success<T>(
        data: T,
        message: String? = null
    ): Response<T>(data = data, message = message)

    @SerialName("error")
    @Polymorphic
    actual class Error<T>(
        message: String,
    ):Response<T>( message = message)

    @SerialName("loading")
    @Polymorphic
    actual class Loading<T>():Response<T>()


    /**
     *     import kotlinx.serialization.Polymorphic
     *     import kotlinx.serialization.SerialName
     *     import kotlinx.serialization.Serializable
     *
     *
     *
     *
     *     @Serializable
     *     open class Response<T>(val data: T? = null, val message: String? = null)
     *
     *     @SerialName("success")
     *     @Polymorphic
     *     class Success<T>(
     *         data: T,
     *         message: String? = null
     *     ): Response<T>(data = data, message = message)
     *
     *     @SerialName("error")
     *     @Polymorphic
     *     class Error<T>(
     *         message: String,
     *     ):Response<T>( message = message)
     *
     *     @SerialName("loading")
     *     @Polymorphic
     *     class Loading<T>():Response<T>()
     *
     *
     *
     *
     *
     */
